import React from 'react'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import { IconTrash } from '@tabler/icons-react'

interface Iprops {
  phone: string
  setPhones: React.Dispatch<React.SetStateAction<string[]>>
}

const EditPhoneRow: React.FC<Iprops> = ({ phone, setPhones }) => {
  const theme = useTheme()

  const removeItem = () => {
    setPhones((prev: string[]) => prev.filter((i: string) => i !== phone))
  }

  return (
    <div className="EditPhoneRow EditEmailRow">
      <div className="row">
        <div className="email">{phone}</div>
        <div className="options">
          <div style={{ borderRight: 'none' }}></div>
          <div style={{ borderRight: 'none' }}></div>
          <div style={{ borderRight: 'none' }}></div>
          <Tooltip className="remove" title="Remove">
            <IconButton onClick={removeItem}>
              <IconTrash
                stroke="none"
                // fill={theme.palette.primary.main}
                color={theme.palette.error.dark}
              />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default EditPhoneRow
